
import { Options, Vue } from 'vue-class-component'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft, faAngleRight, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { mapState } from 'vuex'
import { getDisplayPoint } from '@/utils/functions'
import { TieredPoint } from '@/interfaces/customer-info'
import { DATE_FORMAT, getDate } from '@/helpers/date'
import { useStore } from '@/store'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import ModalIframeOptions from '@/interfaces/modal-iframe-options'
import { getUrlModalOptionsMyCoupon, modalOptionsCouponBZB } from '@/model/modal-options.model'


library.add(faChevronLeft, faAngleRight, faChevronRight)

@Options({
  computed: {
    ...mapState({
      points: (state: any) => state.customer.points,
      tieredPoints: (state: any) => state.customer.tieredPoints,
    }),
  },
  props: {
    isLoadingPoints: Boolean
  },
  components: {
    FontAwesomeIcon,
    QSkeleton
  },
})

export default class CoinHistoryHeader extends Vue {
  private points?: number = undefined
  private tieredPoints: TieredPoint[] | undefined
  private idToken = ''
  store = useStore()

  getLabelPoints(): string {
    return this.points !== undefined
      ? getDisplayPoint(this.points)
      : 'N/A'
  }

  getLabelTieredPoints(): string | undefined {
    if(this.tieredPoints) {
      const expiringPoints = parseFloat(this.tieredPoints[0].expiringPoints)
      const points = getDisplayPoint(expiringPoints) 
      const date =  getDate(this.tieredPoints[0].date, DATE_FORMAT) 

      return  `${points} คอยน์ หมดอายุ ${date}`
    }
  }

  onShowModalTieredPoints() {
    this.store.dispatch('modalTieredPoints/onOpen', true)
  }

  updateModalIframe(isActive: boolean, modalOptions: ModalIframeOptions) {
    this.store.commit('modalIframe/updateModalIframeActive', isActive)
    this.store.commit('modalIframe/updateModalOptionsIframe', modalOptions)
  }

  openModalCouponBZB() {
    const customerType = this.store.state.customer?.customerType ?? undefined
    const socialToken = this.store.state.lineInfo?.socialToken ?? undefined
    modalOptionsCouponBZB.url = getUrlModalOptionsMyCoupon(undefined, 'lifestyle', 'offer', undefined, customerType, socialToken)
    this.updateModalIframe(true, modalOptionsCouponBZB)
  }
}
